export default __webpack_public_path__ + "static/media/Photographs4.82ed2a10.png";